export default __webpack_public_path__ + "static/media/GDPR.9da56fe3.svg";